import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import Routes from './routes';
import {
  IsKeycloakInitialized,
  keycloakInstance,
  keycloakConfig,
} from './helpers/auth';
import SplashScreen from './components/layout/SplashScreen';
import { AuthProvider } from './hooks/AuthContext';
import { Toaster } from '@/components/ui/toaster';
import { StyledToastContainer } from './components/layout/StyledToastContainer';

import './styles/globals.css';

const App: React.FC = () => (
  <Suspense fallback={<SplashScreen />}>
    <ReactKeycloakProvider
      authClient={keycloakInstance}
      autoRefreshToken
      initOptions={keycloakConfig}
    >
      <IsKeycloakInitialized>
        <BrowserRouter>
          <AuthProvider>
            <Routes />
          </AuthProvider>
        </BrowserRouter>
      </IsKeycloakInitialized>
    </ReactKeycloakProvider>
    <Toaster />
    <StyledToastContainer position="bottom-right" />
  </Suspense>
);

export default App;
